// Module
var code = `<form class="form-horizontal" role="form" data-bind="with: request">
  <div class="form-group">
    <label for="DeviceSn" class="requiredMark" data-bind="label: 'cc_P_SHORT_DESCRIPTION'">Short Description</label>
    <textarea
      class="form-control"
      placeholder=""
      data-bind="textInput: cust_prob_descr, hasfocus: true, validationElement: cust_prob_descr"
    ></textarea>
  </div>
  <div class="form-group">
    <label for="DeviceSn" data-bind="label: 'cc_P_EXT_TICKET_NR'">External Ticket Number</label>
    <input
      type="text"
      class="form-control"
      id="DeviceSN"
      placeholder=""
      data-bind="value: reqextens_user_def4"
      maxlength="255"
    ></input>
  </div>
</form>

<div class="row">
  <button
    type="button"
    class="c-button btn btn-primary pull-right"
    data-bind="click: next, enable: request().cust_prob_descr, label: 'cc_Next'"
  >
    Next
  </button>
  <button type="button" class="btn btn-default" data-bind="click: cancel, label: 'Cancel'">Cancel</button>
</div>
`;
// Exports
module.exports = code;